import { usePresence } from "@/contexts/PresenceContext";
import { isStrictAdmin } from "@/helpers/UserHelpers";
import { selectCurrentUser } from "@/services/slices/authSlice";
import { useSelector } from "react-redux";
import "./CursorsOverlay.css";

export default function CursorsOverlay() {
  const user = useSelector(selectCurrentUser);
  const { cursors } = usePresence();

  // Préférence par profil (cursorsEnabled, défaut true). Désactivée => rien.
  if (!isStrictAdmin(user) || user?.cursorsEnabled === false) return null;

  return (
    <div className="rt-cursors-layer" aria-hidden="true">
      {cursors.map((c) => (
        // c.x / c.y = fractions du viewport [0..1]. Positionnement viewport :
        // le curseur reste visible sur la même page quel que soit le scroll.
        <div
          key={c.userId}
          className="rt-cursor"
          style={{
            transform: `translate3d(calc(${c.x} * 100vw), calc(${c.y} * 100vh), 0)`,
          }}
        >
          <svg
            className="rt-cursor__pointer"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              d="M5 3l14 7-6 2-2 6z"
              fill={c.color}
              stroke="#fff"
              strokeWidth="1.3"
              strokeLinejoin="round"
            />
          </svg>
          <span className="rt-cursor__label" style={{ background: c.color }}>
            {c.fullname}
          </span>
        </div>
      ))}
    </div>
  );
}
